// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/weather_actual_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { AreaWeatherActual } from "./weather_actual_model_pb";
import { file_bffuser_v1_weather_actual_model } from "./weather_actual_model_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/weather_actual_service.proto.
 */
export const file_bffuser_v1_weather_actual_service: GenFile = /*@__PURE__*/
  fileDesc("CidiZmZ1c2VyL3YxL3dlYXRoZXJfYWN0dWFsX3NlcnZpY2UucHJvdG8SCmJmZnVzZXIudjEiuwEKG0dldEFyZWFXZWF0aGVyQWN0dWFsUmVxdWVzdBI0CglhcmVhX2NvZGUYASABKA4yFS5iZmZ0eXBlcy52MS5BcmVhQ29kZUIKukgHggEEEAEgABIzChB0YXJnZXRfZGF0ZV9mcm9tGAIgASgLMhEuZ29vZ2xlLnR5cGUuRGF0ZUIGukgDyAEBEjEKDnRhcmdldF9kYXRlX3RvGAMgASgLMhEuZ29vZ2xlLnR5cGUuRGF0ZUIGukgDyAEBIk0KHEdldEFyZWFXZWF0aGVyQWN0dWFsUmVzcG9uc2USLQoGYWN0dWFsGAEgASgLMh0uYmZmdXNlci52MS5BcmVhV2VhdGhlckFjdHVhbDKDAQoUV2VhdGhlckFjdHVhbFNlcnZpY2USawoUR2V0QXJlYVdlYXRoZXJBY3R1YWwSJy5iZmZ1c2VyLnYxLkdldEFyZWFXZWF0aGVyQWN0dWFsUmVxdWVzdBooLmJmZnVzZXIudjEuR2V0QXJlYVdlYXRoZXJBY3R1YWxSZXNwb25zZSIAQkBaPmdpdGh1Yi5jb20vZW5lY2hhaW4vZWJhbGFuY2UvZ28vZ2VuL3Byb3RvL2JmZnVzZXIvdjE7YmZmdXNlcnYxYgZwcm90bzM", [file_bfftypes_v1_area, file_bffuser_v1_weather_actual_model, file_buf_validate_validate, file_google_type_date]);

/**
 * GetAreaWeatherActualRequest carries the area and inclusive target-date
 * range.
 *
 * @generated from message bffuser.v1.GetAreaWeatherActualRequest
 */
export type GetAreaWeatherActualRequest = Message<"bffuser.v1.GetAreaWeatherActualRequest"> & {
  /**
   * Target electricity area. UNSPECIFIED is rejected.
   *
   * @generated from field: bfftypes.v1.AreaCode area_code = 1;
   */
  areaCode: AreaCode;

  /**
   * Inclusive start of the target-date range.
   *
   * @generated from field: google.type.Date target_date_from = 2;
   */
  targetDateFrom?: Date;

  /**
   * Inclusive end of the target-date range. Must be >= target_date_from.
   *
   * @generated from field: google.type.Date target_date_to = 3;
   */
  targetDateTo?: Date;
};

/**
 * Describes the message bffuser.v1.GetAreaWeatherActualRequest.
 * Use `create(GetAreaWeatherActualRequestSchema)` to create a new message.
 */
export const GetAreaWeatherActualRequestSchema: GenMessage<GetAreaWeatherActualRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_weather_actual_service, 0);

/**
 * @generated from message bffuser.v1.GetAreaWeatherActualResponse
 */
export type GetAreaWeatherActualResponse = Message<"bffuser.v1.GetAreaWeatherActualResponse"> & {
  /**
   * @generated from field: bffuser.v1.AreaWeatherActual actual = 1;
   */
  actual?: AreaWeatherActual;
};

/**
 * Describes the message bffuser.v1.GetAreaWeatherActualResponse.
 * Use `create(GetAreaWeatherActualResponseSchema)` to create a new message.
 */
export const GetAreaWeatherActualResponseSchema: GenMessage<GetAreaWeatherActualResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_weather_actual_service, 1);

/**
 * WeatherActualService provides observed weather (JMA AMeDAS, koma-aggregated)
 * for the balance-monitoring screens.
 *
 * @generated from service bffuser.v1.WeatherActualService
 */
export const WeatherActualService: GenService<{
  /**
   * GetAreaWeatherActual returns the koma-aggregated observation series for
   * the area and target-date range. organization_id is resolved by the BFF
   * handler from eauth.
   *
   * @generated from rpc bffuser.v1.WeatherActualService.GetAreaWeatherActual
   */
  getAreaWeatherActual: {
    methodKind: "unary";
    input: typeof GetAreaWeatherActualRequestSchema;
    output: typeof GetAreaWeatherActualResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffuser_v1_weather_actual_service, 0);

